import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    goToProject: string;
    goToFolder: string;
    gotToTrash: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Toast action button label to navigate to the project after an operation */
            goToProject: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useLoadingToast.goToProject?c=3boe512xjliym", defaultMessage: "Go to project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast action button label to navigate to the target folder after an operation */
            goToFolder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useLoadingToast.goToFolder?c=3s2ms0n43z1si", defaultMessage: "Go to folder" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast action button label to view the trash after moving items */
            gotToTrash: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useLoadingToast.gotToTrash?c=3gggk12jubpod", defaultMessage: "View" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
